// extracted by mini-css-extract-plugin
module.exports = {"projectBuildsContainer":"BuildsPage_projectBuildsContainer__2P3lf","buttonContainer":"BuildsPage_buttonContainer__3-qOi"};